<template>
  <div>
    <el-form ref="form" :model="query" label-width="80px" inline size="mini">
      <el-form-item label="联系电话">
        <el-input v-model="query.cellphone" clearable placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="合作模式">
        <el-select v-model="query.mode" clearable placeholder="请选择合作模式">
          <el-option label="加盟合作" :value="1"></el-option>
          <el-option label="商务合作" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="query.state" clearable placeholder="请选择处理状态">
          <el-option label="新录入" :value="0"></el-option>
          <el-option label="跟进中" :value="1"></el-option>
          <el-option label="已解决" :value="2"></el-option>
          <el-option label="未解决" :value="3"></el-option>
          <el-option label="已删除" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" @click="search">搜索</el-button>
    </el-form>

    <el-card>
      <el-table :data="joinApplicationList" style="width: 100%" height="650px" stripe border>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="city" label="意向城市" width="160"></el-table-column>
        <el-table-column label="合作模式" width="100">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.mode === 1">加盟合作</el-tag>
            <el-tag type="success" v-else-if="scope.row.mode === 2">商务合作</el-tag>
            <el-tag type="info" v-else>未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="联系人" width="160"></el-table-column>
        <el-table-column prop="cellphone" label="联系电话" width="160"></el-table-column>
        <el-table-column prop="message" label="留言"></el-table-column>
        <el-table-column prop="remark" label="处理备注" width="200">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" popper-class="join-remark-popper" :open-delay="200" :disabled="!scope.row.remark">
              <div slot="content" class="remark-tooltip">
                <div class="remark-tooltip-title">处理备注</div>
                <div class="remark-tooltip-body">{{ scope.row.remark }}</div>
              </div>
              <div class="remark-cell">{{ scope.row.remark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="处理状态" width="90">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.state === 0">新录入</el-tag>
            <el-tag v-else-if="scope.row.state === 1">跟进中</el-tag>
            <el-tag type="success" v-else-if="scope.row.state === 2">已解决</el-tag>
            <el-tag type="warning" v-else-if="scope.row.state === 3">未解决</el-tag>
            <el-tag type="info" v-else-if="scope.row.state === 4">已删除</el-tag>
            <el-tag type="info" v-else>未知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="warning" size="small" @click="deal(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="pageSizeChange"
        @current-change="curPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <el-dialog title="处理加盟申请" :visible.sync="joinApplicationDialogVisible" @close="close('joinApplicationFormRef')" width="30%">
      <el-form ref="joinApplicationFormRef" :model="joinApplicationForm" :rules="joinApplicationRules" label-width="120px">
        <el-form-item label="处理结果" prop="state">
          <el-select v-model="joinApplicationForm.state" placeholder="请选择处理结果">
            <el-option label="跟进中" :value="1"></el-option>
            <el-option label="已解决" :value="2"></el-option>
            <el-option label="未解决" :value="3"></el-option>
            <el-option label="已删除" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注" prop="remark">
          <el-input
            v-model="joinApplicationForm.remark"
            type="textarea"
            :rows="6"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="joinApplicationDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dealSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { joinApplicationList, editJoinApplication } from '@/API/joinApplication'

export default {
  name: 'joinApplication',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        cellphone: '',
        mode: '',
        state: ''
      },
      joinApplicationList: [],
      total: 0,
      joinApplicationDialogVisible: false,
      joinApplicationForm: {
        uuid: '',
        state: '',
        remark: ''
      },
      currentRemark: '',
      joinApplicationRules: {
        state: [{ required: true, message: '请选择处理结果', trigger: 'change' }],
        remark: [{ required: true, message: '请输入处理备注', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getJoinApplicationList()
  },
  methods: {
    async getJoinApplicationList() {
      const { data: res } = await joinApplicationList(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.joinApplicationList = res.data.entities
      this.total = res.data.totalSize
    },
    search() {
      this.query.curPage = 1
      this.getJoinApplicationList()
    },
    deal(row) {
      this.currentRemark = row.remark || ''
      this.joinApplicationForm.uuid = row.uuid
      this.joinApplicationForm.remark = ''
      this.joinApplicationDialogVisible = true
    },
    async dealSubmit() {
      this.$refs.joinApplicationFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await editJoinApplication({
          ...this.joinApplicationForm,
          remark: this.appendRemark(this.currentRemark, this.joinApplicationForm.remark)
        })
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$refs.joinApplicationFormRef.resetFields()
          this.joinApplicationDialogVisible = false
          this.getJoinApplicationList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getJoinApplicationList()
    },
    curPageChange(newPage) {
      this.query.curPage = newPage
      this.getJoinApplicationList()
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
      this.currentRemark = ''
    },
    appendRemark(oldRemark, newRemark) {
      const time = this.formatTime(new Date())
      const remark = newRemark
        .trim()
        .split(/\r?\n/)
        .map(item => `${time} ${item}`)
        .join('\n')
      if (!oldRemark) return remark
      return `${oldRemark}\n${remark}`
    },
    formatTime(date) {
      const pad = value => `${value}`.padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style lang="less" scoped>
.el-form {
  .el-input {
    width: 180px;
  }
  .el-select {
    width: 180px;
  }
}
.el-pagination {
  margin-top: 30px;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    width: 33%;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
.remark-cell {
  color: #606266;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remark-cell:hover {
  color: #409eff;
}
</style>

<style lang="less">
.join-remark-popper {
  max-width: 460px;
  padding: 0 !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 6px;
  color: #303133 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
}
.join-remark-popper .remark-tooltip {
  min-width: 260px;
  max-width: 460px;
}
.join-remark-popper .remark-tooltip-title {
  padding: 10px 14px;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}
.join-remark-popper .remark-tooltip-body {
  max-height: 280px;
  padding: 12px 14px;
  overflow-y: auto;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-line;
}
</style>
